export default __webpack_public_path__ + "static/media/vue.8a06a591.svg";